// extracted by css-extract-rspack-plugin
export default {"row":"aJZcHN1UAA72PE5M"};